// Quiz Button Directive
SUGApp.directive('sugModal', ['quizService', 'SUGUtilities', '$modal', function (qsrv, util, modal ) {
    return {
        scope: {
            sugModal: '@'
        },

        restrict:'AE',
        link:function ($scope, element, attrs) {
            $scope.manageQuiz = function() {

                function quizLoad(){

                    // Grab Quiz Information, based on the passed Quiz Name

                    // If number, find quiz by ID
                    qsrv.getQuizByName({
                        quizname: $scope.sugModal
                    }).then(function (response) {
                        if (qsrv.ajaxResultInvalid(response)) {
                            // invalid response, show error
                            qsrv.errorHandler(response.data);

                        } else {
                            // valid response, get the quiz data
                            var r = util.lowerCaseKeys(response);


                            if (typeof r.data.data.quiz !== 'undefined' && r.data.data.quiz.length) {
                                $scope.quizData = r.data.data.quiz[0];
                                $scope.quizPath = angular.fromJson($scope.quizData.config);
                            }

                            // Start the Quiz instance - send the quizid, location
                            var data = {};
                            $scope.quizInstanceID = {};

                            data.quizid = $scope.quizData.id;
                            data.location = location.href;

                            qsrv.startQuiz(data)
                                .then(function (startResponse){
                                    if (qsrv.ajaxResultInvalid(response)) {
                                        // invalid response, show error
                                        qsrv.errorHandler(response.data);
                                    } else {
                                        $scope.quizInstanceID = startResponse.data.DATA.quizinstanceid;
                                        // Load Modal with Retrieved Quiz Information
                                        $scope.quizModalInstance = modal.open({
                                            templateUrl: '/view/templates/quiz/quizTemplate.html',
                                            // Check the version of the quiz and set the controller based on the value
                                            controller: "quizControllerV2",
                                            resolve: {
                                                quiz: function () { return $scope.quizData; },
                                                quizInstanceID: function(){ return $scope.quizInstanceID; },
                                                quizVersion: function() { return $scope.quizData.quizversion; }
                                            }
                                        }).result.then(
                                            function (result) {
                                                //works!
                                            }, function (){
                                                //broken!!
                                            });
                                    }
                                });
                        }
                    });

                }

                quizLoad();

            };
            element.bind('click', $scope.manageQuiz);
        }
    };
}]).controller('quizControllerV2', ['quizService','SUGUtilities','errorService','$scope', 'quiz', 'quizInstanceID', 'quizVersion', '$modalInstance', '$modal', '$location', '$window', function (qsrv, util, errorService, $scope, quiz, quizInstanceID, quizVersion, modalInstance, modal, $location, w) {
        
    // instantiate error handler
    $scope.es = errorService.newInstance();
    $scope.errorStrings = {
        errorsTitle: '',
        errorsPleaseCorrect: 'Please correct the issues indicated below.'
    };

    var init = function () {
        // This contains all the current quiz data
        $scope.quizInformation = JSON.parse(quiz.config);
        $scope.quizInstance = quizInstanceID;
        $scope.quizVersion = quizVersion;

        // Set intial template
        $scope.templateid = $scope.quizInformation.starttemplateid;
        $scope.templateInfo = {};
        $scope.loadTemplate($scope.templateid, 1);

        $scope.savedAnswers = [];
        $scope.savedOptionClasses = [];
        $scope.recommendedPlan = [];
        $scope.recordedAnswers = [];
        $scope.recommendation = "";
        $scope.showNextButton = false;
        $scope.showPreviousButton = false;

        $scope.strings = {};
        $scope.strings.errors= {
            noRecommendationFound: 'No recommendation could be found for the selected answer(s).'
        };
        $scope.useAnnualPricing = true;
        $scope.showSwitch = true;
        $scope.selectedPath = "";
    };

    //dismisses the modal
    $scope.cancel = function () {
        modalInstance.dismiss();
    };

    // sets $scope.pageload to the template path associated with the templateid
    $scope.loadTemplate = function ( templateid, direction ) {
        // If we are loading the results page, complete the quiz
        if (templateid === $scope.quizInformation.endtemplateid) {
            // If the recommendation is enterprise or basic, do not show the monthly/annual selector switch
            if ($scope.recommendation.toLowerCase() == "enterprise" || $scope.recommendation.toLowerCase() == "basic") {
                $scope.showSwitch = false;
            } else {
                $scope.showSwitch = true;
            }
            $scope.completeQuiz();
        }

        // Set the previous templateid to the current one before updating templateid value. This only works when moving forward
        var previoustemplateid = "";

        if (templateid === $scope.quizInformation.starttemplateid) {
            previoustemplateid = "";
        } else if (direction === 0) {
            // If the function call was triggered by the Previous button being clicked, we need to determine the correct templateid for the previous template (after the template loads) by looping over the options and finding the correct template
            var templates = $scope.quizInformation.templates;

            outerLoop: for (var i in templates) {
                // Have to use nested loops to find the element
                innerLoop: for (var j=0; j < templates[i].next.length; j++){
                    if (templates[i].next[j].templateid == templateid) {
                        previoustemplateid = i;
                        // If value is found we are done. break out of the outer loop
                        break outerLoop;
                    }
                }
            }

        } else {
            previoustemplateid = $scope.templateid;
        }
        $scope.previoustemplateid = previoustemplateid;
        $scope.showPreviousButton = $scope.previoustemplateid.length ? true : false;
        
        $scope.templateid = templateid;
        $scope.templateInfo = $scope.quizInformation.templates[$scope.templateid];
        $scope.pageload = '/view/templates/quiz/' + $scope.templateInfo.path;
    };
    
    // evaluates the answer and determines the recommended plan basd on the answer
    $scope.evaluateAnswer = function (answer, multiSelect) {
        var recommendedPlan = 'basic';
        var options = $scope.templateInfo.options;

        if (multiSelect) {
            // If dealing with a multiselect template, we have to reevaluate the entire array of answers to find the highest plan recommendation for the selected answers
            var answerArray = $scope.savedAnswers;
            // Set attay to 
            var recArray = [];
            // Loop over answer array
            for (var i=0; i<answerArray.length; i++) {
                for (var option = 0; option < options.length; option++) {
                    // if the answer matches the value, and the recommendation is not already in the recArray, add it
                    if (answerArray[i] === options[option].value && recArray.indexOf(options[option].result) === -1) {
                        recArray.push(options[option].result);
                        break;
                    }
                }
            }
            // Determine the highest priority plan in the recArraya and return it
            recommendedPlan = $scope.getRecommendation(recArray);

        } else {
            for (var option = 0; option < options.length; option++) {
                if (answer === options[option].value) {
                    recommendedPlan = options[option].result;
                    break;
                }
            }
        }
        return recommendedPlan;
    };

     // Setting which template we should go to next - idealy we can put some logic to set up any next page that we want to load
    $scope.setNextTemplate = function (matchvalue){
        if ($scope.templateInfo.next.length === 1) {
            // Handle single next option
            if ($scope.templateInfo.next[0].matchtype === 'default') {
                // If matchtype is default set the next templateid to the value of the templateid
                $scope.nexttemplateid = $scope.templateInfo.next[0].templateid;
            }
        } else if ($scope.templateInfo.next.length > 1) {
            // Handle multiple next options
            // loop over next array and evaluate the options
            for ( var node = 0; node < $scope.templateInfo.next.length; node++ ) {
                
                if ($scope.templateInfo.next[node].matchtype==='exact') {
                    // If matchtype if exact, loop over possible matches                    
                    for (var match=0; match < $scope.templateInfo.next[node].matches.length; match++) {
                        // If the value passed in matches the match value, set the next templateid to the value of the element
                        if ($scope.templateInfo.next[node].matches[match]===matchvalue) {
                            $scope.nexttemplateid = $scope.templateInfo.next[node].templateid;
                            break;
                        }
                    }
                    
                }
            }
        } else {
            // Handle no next options
            $scope.nexttemplateid = "";
        }

        // Added check that savedAnswers has values to prevent the Next button from showing when unselecting all options on multi select templates
        $scope.showNextButton = $scope.templateid !== $scope.quizInformation.endtemplateid && $scope.nexttemplateid.length && $scope.savedAnswers.length ? true : false;
        $scope.showPreviousButton = $scope.templateid !== $scope.quizInformation.starttemplateid && $scope.previoustemplateid.length ? true : false;

    };

    // Saving whatever selections that users made
    $scope.saveAnswerData = function (selectedAnswer, selectedOptionClass, allowMultiple) {
        // if multiple selections are allowed
        if (allowMultiple){
            if ( $scope.savedAnswers.length <= 0 ){
                $scope.savedAnswers.push(selectedAnswer);
            } else {
                if ( $scope.savedAnswers.indexOf(selectedAnswer) === -1 ) {
                    $scope.savedAnswers.push(selectedAnswer);
                } else {
                    $scope.savedAnswers.splice($scope.savedAnswers.indexOf(selectedAnswer), 1);
                }
            }
            // Store option classes for selected answers
            if ( $scope.savedOptionClasses.length <= 0 ){
                $scope.savedOptionClasses.push(selectedOptionClass);
            } else {
                if ( $scope.savedOptionClasses.indexOf(selectedOptionClass) == -1 ) {
                    $scope.savedOptionClasses.push(selectedOptionClass);
                } else {
                    $scope.savedOptionClasses.splice($scope.savedOptionClasses.indexOf(selectedOptionClass), 1);
                }
            }
        } else {
            $scope.savedAnswers = [];
            $scope.savedAnswers.push(selectedAnswer);
            // Store option class for selected answer
            $scope.savedOptionClasses = [];
            $scope.savedOptionClasses.push(selectedOptionClass);
        }

        // if all answers are unselected, remove the next button to prevent the user from proceeding
        if (typeof $scope.savedAnswers == 'undefined' || !$scope.savedAnswers.length) {
            $scope.showNextButton = false;
        }
    };


    // Save recorded answers so they can be retrieved when navigating to previous templates
    $scope.saveRecordedAnswers = function(templateid, answer, multiSelect) {
        // Get the recommendation corresponding to the answer
        var recommendedPlan = $scope.evaluateAnswer(answer, multiSelect);

        // Finding which spot in the array we are using
        function getIndexOf(quizList,currentPath) {
            for (var k=0; k < quizList.length; k++) {
                if (quizList[k].templateid==currentPath) {
                    return k;
                }
            }
            return -1;
        }
        // Get index of template in recorded answers array
        var currentTemplate = getIndexOf($scope.recordedAnswers,templateid);
        //if template allows multiple, need to remove old one, and replace with new one
        //if template exists, update instead of adding.
        if ( $scope.recordedAnswers.length > 0 && currentTemplate > -1 ){
            if ( !multiSelect ){
                $scope.recordedAnswers[currentTemplate].answers = answer;
                $scope.recordedAnswers[currentTemplate].recommendation = recommendedPlan;
            } else {
                $scope.recordedAnswers[currentTemplate].answers = $scope.savedAnswers;
                $scope.recordedAnswers[currentTemplate].recommendation = recommendedPlan;
            }
        // if recordedAnswers is an empty string or an entry for the templateid does not exist, add the entry
        } else {
            $scope.recordedAnswers.push({"templateid": templateid, "answers": answer, "recommendation": recommendedPlan});
        }
    };

    // Retrieve previously saved answers when navigating using the Previous button
    $scope.getRecordedAnswer = function (templateid) {
        // Finding which spot in the array we are using
        function getIndexOf(quizList,currentPath) {
            for (var k=0; k < quizList.length; k++) {
                if (quizList[k].templateid==currentPath) {
                    return k;
                }
            }
            // If not found, return -1
            return -1;
        }
        // Get index of template in recorded answers array
        var currentTemplate = getIndexOf($scope.recordedAnswers,templateid);

        if (currentTemplate > -1) {
            // Determine if the template uses checkboxes to display options, so we can set the checkboxes for the selected options
            var setCheckboxValues = $scope.quizInformation.templates[templateid].useCheckboxOptions;

            //$scope.savedAnswers needs to be an array or else it will cause errors so we need to make sure that we set that value as an array. It might be coming in as a string or an array (which typeof evaluates as object) here based on the V2 JSON schema. 
            $scope.savedAnswers = typeof $scope.recordedAnswers[currentTemplate].answers === 'object' ? $scope.recordedAnswers[currentTemplate].answers : [$scope.recordedAnswers[currentTemplate].answers];
            
            // Call $scope.setNextTemplate so the nexttemplateid will be set correctly. This is necessary when the user is navigating back and forth with the Previous/Next buttons to maintain the correct next template
            $scope.setNextTemplate($scope.recordedAnswers[currentTemplate].answers);

            // loop over the options for the template. If any are found in the saved answers, append them to the savedOptionClasses array so the corresponding builbs will properly light up
            var templateOptions = $scope.quizInformation.templates[templateid].options;
            for (var i=0; i < templateOptions.length; i++) {
                if ($scope.savedAnswers.indexOf(templateOptions[i].value) > -1) {
                    $scope.savedOptionClasses.push(templateOptions[i].optionclass);
                    // If the template used checkboxes, set the value
                    if (setCheckboxValues) {
                        $scope.checkboxes[templateOptions[i].value].isChecked = true;
                    }
                }
                
            }
        } else {
            $scope.savedAnswers = [];
        }
    };


    
    // Handles all of the actions when a user selects an answer.
    $scope.selectAnswer = function (answer, option) {
        
        // When viewing the start template check if the branch path has changed and clear saved data when it does
        if ($scope.templateid === $scope.quizInformation.starttemplateid) {
            var newSelectedPath = answer;
            // If changing paths, clear recorded answers so they don't interfere with results
            if (newSelectedPath != $scope.selectedPath) {
                $scope.recordedAnswers = [];
            }
            // Set the new path
            $scope.selectedPath = newSelectedPath;
        }

        // Otherwise processes the selection
        $scope.saveAnswerData(answer, option, $scope.templateInfo.allowMultipleSelection);
        $scope.saveRecordedAnswers($scope.templateid, answer, $scope.templateInfo.allowMultipleSelection);
        $scope.setNextTemplate(answer);
    };


    $scope.loadNextTemplate = function (direction) {
        // Submitting the answers; quizinstanceid, template, answer {quizinstanceid: 1, template: 'quiz-step-1.html', answer: 'my answer'}
        var data = {};  

        data = {
            quizinstanceid : $scope.quizInstance,
            template : $scope.templateInfo.path,
            answer : $scope.savedAnswers.toString()
        };

        qsrv.answerQuiz(data)
            .then(function (response){
                var r = util.lowerCaseKeys( response );
                if (!r.data.success) {
                    $scope.es.setError('error-top-level',r.data.message);
                }
            });

        // Rebuild the recommendedPlan array on every template load, so we can get a clean recommendation from the recorded answers for all templates that have been views so far
        $scope.recommendedPlan = [];
        for (var x=0; x<$scope.recordedAnswers.length; x++) {
            $scope.recommendedPlan.push($scope.recordedAnswers[x].recommendation);
        }
        $scope.recommendation = $scope.getRecommendation($scope.recommendedPlan);

        // Hide buttons and clear saved buttons on template change
        $scope.showPreviousButton = false;
        $scope.showNextButton = false;
        $scope.savedAnswers = [];
        $scope.savedOptionClasses = [];
        
        var template = direction === 0 ? $scope.previoustemplateid : $scope.nexttemplateid;
        // Set pageload template based on whether previous or next button is selected
        $scope.pageload = '/view/templates/quiz/' + $scope.quizInformation.templates[template].path;
        // If the template uses checkboxes to display the options, we need to build on object to use as the model for the checkboxes
        if ($scope.quizInformation.templates[template].useCheckboxOptions) {
            $scope.checkboxes = {};
            for (var x=0; x<$scope.quizInformation.templates[template].options.length; x++) {
                $scope.checkboxes[$scope.quizInformation.templates[template].options[x].value] = { 'isChecked': false};
            }
        } else {
            $scope.checkboxes = {};
        }
        // Retrieve the selected answers for template before loading it and determining the new templateid
        $scope.loadTemplate(template, direction);
        $scope.getRecordedAnswer(template);

    };
    
   
    // calls quizService.completeQuiz() 
    $scope.completeQuiz = function () {
        var data = {};
        data = {
            quizinstanceid: $scope.quizInstance,
            result: $scope.recommendation
        };
        qsrv.completeQuiz(data)
        .then(function (response) {
            var r = util.lowerCaseKeys( response );
            if (!r.data.success) {
                $scope.es.setError('error-top-level',r.data.message);
            }
        });
    };
    
    // Uses the recommendationsArray and finds the highest priority result ( see results > priority in   )
    // returns the highest priority result
    $scope.getRecommendation = function ( answersArray ) {
        var returnValue = '';
        // Stores the index value of the priority of the recommendation. The lower the value the higher the priority. Set to a high number to start so it will always correctly lower the first iteration of the loop, below
        var recIndex = 100000;
        var recValue= '';
        var priority = 0;
        for (var a = 0; a < answersArray.length; a++) {
            recValue = answersArray[a];
            priority = $scope.quizInformation.results.priority.indexOf(recValue);
            // If the recommendation has not been set or the priority of the recommendation is lower than the currently selected recommendation, set the recommendation to the new value, because it has highter priority
            if (priority < recIndex) {
                recIndex = priority;
                returnValue = recValue;
            }
        }
        return returnValue;

    };
       
    // executes the jsvent specified, should validate that it only allows “ga()” jsevents, any other event should be console logged and not executed (silent error)
    $scope.fireJsEvent = function (conversionIndex) {
        var jsevents = $scope.quizInformation.results.definitions[$scope.recommendation].conversions[conversionIndex].jsevents;

        // Verify that only ga calls are run
        if (jsevents.substring(0,2)=='ga') {
            // Dynamic function call for google analytics call retrieved from 
            var callGA = function () {
                eval(jsevents);
            };          
            callGA();
        } else {
            console.log(jsevents);
        }

        var productcode = $scope.quizInformation.results.definitions[$scope.recommendation].productcodeannual;
        var url =  $scope.quizInformation.results.definitions[$scope.recommendation].conversions[conversionIndex].link;
        // Apped the product code to the url if the recommendation is not basic or enterprise
        if ($scope.recommendation != 'enterprise' && $scope.recommendation != 'basic') {
            if (url.indexOf('?') > -1) {
                url = url + "&productcode="+productcode;
            } else {
                url = url + "?productcode="+productcode;
            }
        }
        //open the buy now link in a new window
        w.open(url, 'newpricingwindow');
    };

    $scope.togglePrice = function(){
        // Change this to show and hide divs now
        $scope.useAnnualPricing = !$scope.useAnnualPricing;
        
    };

    init();
}]);
